import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import { OfflineRequestsForm } from '../OfflineRequests.entity';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    offlineRequestWorkDetail: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/OfflineRequestWork/${data.id}`,
      }),
    }),
    offlineRequestWorkMoveToRequest: builder.mutation<void, OfflineRequestsForm>({
      query: (data) => ({
        url: `/v1/OfflineRequestWork/${data.id}/moveToRequest`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useOfflineRequestWorkDetailQuery,
  useOfflineRequestWorkMoveToRequestMutation,
  useLazyOfflineRequestWorkDetailQuery,
} = request;
